import { JsonUtils } from '../../utils/json.util'

export class User {
    private _id?: string | undefined
    private _name: string | undefined
    private _cpf: string | undefined
    private _organization_id: string | undefined
    private _organization_logo: any | undefined
    private _email: string | undefined
    private _institutional_registration?: string | undefined
    private _institutional_position?: string | undefined
    private _password?: string | undefined
    private _phone?: string | undefined
    private _active?: boolean | undefined
    private _type: string | undefined
    private _last_login?: string | undefined
    private _uf_logo?: any | undefined
    private _resources: Array<string> | undefined
    private _created_at?: string | undefined
    private _updated_at?: string | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get name(): string | undefined {
        return this._name
    }

    set name(value: string | undefined) {
        this._name = value
    }

    get cpf(): string | undefined {
        return this._cpf
    }

    set cpf(value: string | undefined) {
        this._cpf = value
    }

    get organization_id(): string | undefined {
        return this._organization_id
    }

    set organization_id(value: string | undefined) {
        this._organization_id = value
    }

    get email(): string | undefined {
        return this._email
    }

    set email(value: string | undefined) {
        this._email = value
    }

    get institutional_registration(): string | undefined {
        return this._institutional_registration
    }

    set institutional_registration(value: string | undefined) {
        this._institutional_registration = value
    }

    get institutional_position(): string | undefined {
        return this._institutional_position
    }

    set institutional_position(value: string | undefined) {
        this._institutional_position = value
    }

    get password(): string | undefined {
        return this._password
    }

    set password(value: string | undefined) {
        this._password = value
    }

    get phone(): string | undefined {
        return this._phone
    }

    set phone(value: string | undefined) {
        this._phone = value
    }

    get active(): boolean | undefined {
        return this._active
    }

    set active(value: boolean | undefined) {
        this._active = value
    }

    get last_login(): string | undefined {
        return this._last_login
    }

    set last_login(value: string | undefined) {
        this._last_login = value
    }

    get resources(): Array<string> | undefined {
        return this._resources
    }

    set resources(value: Array<string> | undefined) {
        this._resources = value
    }

    get uf_logo(): any {
        return this._uf_logo
    }

    set uf_logo(value: any) {
        this._uf_logo = value
    }

    get organization_logo(): any {
        return this._organization_logo
    }

    set organization_logo(value: any) {
        this._organization_logo = value
    }

    get created_at(): string | undefined {
        return this._created_at
    }

    set created_at(value: string | undefined) {
        this._created_at = value
    }

    get updated_at(): string | undefined {
        return this._updated_at
    }

    set updated_at(value: string | undefined) {
        this._updated_at = value
    }

    get type(): string | undefined {
        return this._type
    }

    set type(value: string | undefined) {
        this._type = value
    }

    public fromJSON(json: any): User {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.id !== undefined) {
            this.id = json.id
        }

        if (json.name !== undefined) {
            this.name = json.name
        }

        if (json.email !== undefined) {
            this.email = json.email
        }

        if (json.cpf !== undefined) {
            this.cpf = json.cpf
        }

        if (json.phone !== undefined) {
            this.phone = json.phone
        }

        if (json.institutional_position !== undefined) {
            this.institutional_position = json.institutional_position
        }

        if (json.institutional_registration !== undefined) {
            this.institutional_registration = json.institutional_registration
        }

        if (json.organization_id !== undefined) {
            this.organization_id = json.organization_id
        }

        if (json.password !== undefined) {
            this.password = json.password
        }

        if (json.active !== undefined) {
            this.active = json.active
        }

        if (json.last_login !== undefined) {
            this.last_login = json.last_login
        }

        if (json.type !== undefined) {
            this.type = json.type
        }

        if (json.resources !== undefined) {
            this.resources = json.resources
        }

        if (json.uf_logo !== undefined) {
            this.uf_logo = json.uf_logo
        }

        if (json.organization_logo !== undefined) {
            this.organization_logo = json.organization_logo
        }

        if (json.created_at !== undefined) {
            this.created_at = json.created_at
        }

        if (json.updated_at !== undefined) {
            this.updated_at = json.updated_at
        }

        return this
    }

    public toJSON(): any {
        return {
            id: this.id || undefined,
            name: this.name || undefined,
            email: this.email || undefined,
            cpf: this.cpf || undefined,
            phone: this.phone || undefined,
            password: this.password || undefined,
            organization_id: this.organization_id || undefined,
            institutional_position: this.institutional_position || undefined,
            institutional_registration: this.institutional_registration || undefined,
            active: this.active || undefined,
            type: this.type || undefined,
            last_login: this.last_login || undefined,
            resources: this.resources || undefined,
            uf_logo: this.uf_logo || undefined,
            organization_logo: this.organization_logo || undefined,
            created_at: this.created_at || undefined,
            updated_at: this.updated_at || undefined
        }
    }
}
